import { createFileRoute } from '@tanstack/react-router';
import { ProductionView } from '../../production/production-view.js';

export const Route = createFileRoute('/_station/production')({
  component: ProductionView,
});
